// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6ae0fad7","160":"9fd6f7b0","208":"4b989c3a","293":"1d52d940","453":"90cd05a9","516":"062425d5","519":"1f717332","917":"36366504","946":"47711e7d"}[chunkId] + ".chunk.js";
};